import { DateTime } from "luxon";
import { ServiceType } from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { SortOrder } from "../Domain/OrderRequestList.types";
import { OrderRequestData } from "../Domain/RemoteOrderRequests.types";
import { orderRequestMatchesServiceTypeFilter } from "./orderRequestServiceTypeFilter.function";

export function filterOrderRequestData({
  data,
  searchText,
  filterByType,
  sortOrder
}: {
  data: OrderRequestData[];
  searchText: string;
  filterByType: ServiceType[];
  sortOrder: SortOrder;
}): OrderRequestData[] {
  let result = data.filter(item => {
    const matchesText =
      item.inventoryName.toLowerCase().includes(searchText) ||
      item.locationName.toLowerCase().includes(searchText) ||
      item.floorName.toLowerCase().includes(searchText) ||
      item.requestedByUser.toLowerCase().includes(searchText);

    const matchesType = filterByType.some(type => orderRequestMatchesServiceTypeFilter(item, type));

    return matchesText && matchesType;
  });

  // sort by text or date, ascending or descending
  result = result.sort((a, b) => {
    if (sortOrder === SortOrder.DateAscending || sortOrder === SortOrder.DateDescending) {
      return sortOrder === SortOrder.DateAscending
        ? DateTime.fromISO(a.date).valueOf() - DateTime.fromISO(b.date).valueOf()
        : DateTime.fromISO(b.date).valueOf() - DateTime.fromISO(a.date).valueOf();
    } else {
      const nameA = a.inventoryName.toLowerCase();
      const nameB = b.inventoryName.toLowerCase();
      return sortOrder === SortOrder.NameAscending
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    }
  });

  return result;
}
